import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { sanitizeInput } from "./sanitize-input";

/**
 * custom hook that provides sanitized input handling
 * @param onChange - the original onChange function from react-hook-form
 * @returns sanitized onChange handler that prevents script injection
 */
export function useSanitizedInput(onChange) {
  const $ = _c(2);
  let t0;
  if ($[0] !== onChange) {
    t0 = e => {
      const sanitizedValue = sanitizeInput(e.target.value);
      onChange(sanitizedValue);
    };
    $[0] = onChange;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}

/**
 * creates a sanitized input field with proper onChange handling
 * @param field - the field object from react-hook-form
 * @returns enhanced field object with sanitized onChange
 */
export function createSanitizedField<T extends {
  onChange: (value: any) => void;
}>(field: T) {
  return {
    ...field,
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const sanitizedValue = sanitizeInput(e.target.value);
      field.onChange(sanitizedValue);
    }
  };
}